import React, { useEffect, useState } from "react";
import { Link, useParams } from "react-router-dom";
import Select from "react-select";
import Header from "../layouts/Header";
import Sidebar from "../layouts/Sidebar";
import axios from "../api/axios";
import FindModuleById from '.././FindModuleById';
import { useFormik, FormikProvider, FieldArray } from "formik";
import {  Apitoken, Authtoken  } from "../Global";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import AWS from 'aws-sdk';
import { AWS_ACCESS_KEY_ID, AWS_SECRET_ACCESS_KEY, AWS_DEFAULT_REGION,AWS_BUCKET } from "../Global";
import $ from "jquery";
const LocationtableEdit = () => {
  let { id } = useParams();


  const [value, setValue] = useState({});
  const [valueContents, setValueContents] = useState([]);
  const [fileTypes, setFileTypes] = useState([]);
  const [backendErrors, setBackendErrors] = useState([]);
  const [permission, setPermission] = useState({});
  const [menu, setMenu] = useState(false);
  const toggleMobileMenu = () => {
    setMenu(!menu);
  };
  

  const formik = useFormik({
    initialValues: {
      id: id,
      title: value.title,
      gps_location:value.gps_location,
      numero_de_station:value.numero_de_station,
      description: value.description,
      n_onssa:value.n_onssa,
      n_exportateur:value.n_exportateur,
    
      files: valueContents,
    },
    enableReinitialize: true,
    onSubmit: (values, { setSubmitting }) => {
      axios
        .post("/locations/update", values, {
          headers: { Authorization: `Bearer ${Authtoken}`, Apitoken: Apitoken },
        })
        .then((response) => {
          delete backendErrors['error'];
          $("#form-submit").text("Update Location"); 
          setSubmitting(false);
          //actions.setSubmitting(false);
          if (response.data.code === 200) {
            //setBackendSuccess(response.data.message);
            toast.success(response.data.message);
            //actions.resetForm();
            setTimeout(() => {
              window.location.href = "/locations";
            }, 1000);
          }
            else if (response.data.code === 422) {
              setBackendErrors(response.data.error);
          }
          else if (response.data.code === 401) {
            setBackendErrors(response.data.error);
          }
          else {
             setBackendErrors(response.data.error);
          }
        })
        .catch((error) => {
          console.log(error);
        });
    },
  });

  useEffect(() => {
        setPermission(FindModuleById(221)); 
        console.log(permission);

     axios
      .get(`/helpers/certification-file-types`, {
        headers: { Authorization: `Bearer ${Authtoken}`, Apitoken: Apitoken },
      })
      .then((response) => {
        if (response.data.code === 200) {
          let types = response.data.data.certificates;
          let typeslisting = types.map((ord, index) => ({
            label: ord.title,
            value: ord.id,
            key: `location-${index}`,
          }));
          setFileTypes(typeslisting);
        } else {
          console.log("API response is not an array");
        }
      })
      .catch((error) => {
        console.log(error);
      });
  }, []);
 

  const customHandleInput = (event) => {
    const Input_name = event.target.name;
    delete backendErrors[Input_name];
  };
  useEffect(() => {
    axios
      .get(`/locations/edit/${id}`, {
        headers: { Authorization: `Bearer ${Authtoken}`, Apitoken: Apitoken },
      })
      .then((response) => {
        if (response.data.code === 200) {
          setValue(response.data.data.location);
          setValueContents(response.data.data.location.files);
        }
      })
      .catch((error) => {
        toast.error(error);
      });

  
 

  }, [id]);
  const viewFile =(link) =>{
    AWS.config.setPromisesDependency(); //use so you can promisify to get the actual images
    AWS.config.update({
    accessKeyId: AWS_ACCESS_KEY_ID,
    secretAccessKey: AWS_SECRET_ACCESS_KEY,
    region: AWS_DEFAULT_REGION,
    signatureVersion: 'v4',
    });
    const s3 = new AWS.S3();
    var params = {Bucket: AWS_BUCKET, Key: link};
    return  s3.getSignedUrl('getObject', params);
  }

      
  const getFileData = async (event) =>{
    const file_link = event.target.files[0];
    const fileName = file_link.name;
    const withoutExtension = fileName.replace(/\.[^.]+$/, '');

    var id_value = event.target.id;
    const ids = id_value.split("-");
    formik.values.files[ids[1]].file_name = withoutExtension;
  } 

  
  const deleteItemFromDB = (item_id) => {
    const  response_data = {};
    response_data.status = 'false';
    axios.get(`/locations/delete-certificates/${item_id}`, {
      headers: { Authorization: `Bearer ${Authtoken}`, Apitoken: Apitoken },
    }).then((response) => {
      if (response.data.code === 200) {
        response_data.status = 'ok';
        return response_data;
      }
    }).catch((error) => {
      console.log(error)
      response_data.status = 'false';
    
    });
    return response_data;
  };
  return (
    <>
      <div className={`main-wrapper ${menu ? "slide-nav" : ""}`}>
        <Header onMenuClick={() => toggleMobileMenu()} />
        <Sidebar />  <ToastContainer />

        <div className="page-wrapper">
          <div className="content container-fluid">
            <div className="page-header">
              <div className="row">
                <div className="col-sm-12">
                  <h3 className="page-title">Processing Line</h3>
                  <ul className="breadcrumb">
                    <li className="breadcrumb-item">
                      <Link to="/profile">Profile</Link>
                    </li>
                    <li className="breadcrumb-item">
                      <Link to="/locations">
                      Processing Lines
                      </Link>
                    </li>
                    <li className="breadcrumb-item active">
                      Edit Processing Line
                    </li>
                  </ul>
                </div>
              </div>
            </div>

            <div className="row">
              <div className="col-md-12">
                <div className="card">
                {permission && permission.update === 1 && (
                  <div className="card-body">
                    <h4 className="card-title">Processing Line Information</h4>
                    <FormikProvider value={formik}>
                      <form action="#" onSubmit={formik.handleSubmit}>
                        <div className="row">
                        <div className="col-md-6">
                            <div className="form-group">
                                <label>Title</label>
                                <input
                                  type="text"
                                  name="title"
                                  value={formik.values.title}
                                  className={
                                    backendErrors.title
                                      ? "form-input form-control input-error"
                                      : "form-input form-control"
                                  }
                                  onChange={(e) => {
                                    formik.handleChange(e);
                                    customHandleInput(e);
                                  }}
                                  onBlur={formik.handleBlur}
                                />
                                <small>
                                  {backendErrors.title && (
                                      <span className="form-error mt-1">
                                        {backendErrors.title}
                                      </span>
                                    )}
                                </small>
                              </div>
                          </div>
                          <div className="col-md-6">
                            <div className="form-group">
                                <label>GPS Location</label>
                                <input
                                  type="text"
                                  name="gps_location"
                                  value={formik.values.gps_location}
                                  className={
                                    backendErrors.gps_location
                                      ? "form-input form-control input-error"
                                      : "form-input form-control"
                                  }
                                  onChange={(e) => {
                                    formik.handleChange(e);
                                    customHandleInput(e);
                                  }}
                                  onBlur={formik.handleBlur}
                                />
                                <small>
                                  {backendErrors.gps_location && (
                                      <span className="form-error mt-1">
                                        {backendErrors.gps_location}
                                      </span>
                                    )}
                                </small>
                              </div>
                          </div>
                          
                          <div className="col-md-6">
                            <div className="form-group">
                                <label>Numero De Station</label>
                                <input
                                  type="text"
                                  name="numero_de_station"
                                  value={formik.values.numero_de_station}
                                  className={
                                    backendErrors.numero_de_station
                                      ? "form-input form-control input-error"
                                      : "form-input form-control"
                                  }
                                  onKeyPress={(event) => {
                                    // Allow only numbers (0-9)
                                    if (!/^[0-9]$/.test(event.key)) {
                                    event.preventDefault();
                                    }
                                  }}
                                  onChange={(e) => {
                                    formik.handleChange(e);
                                    customHandleInput(e);
                                  }}
                                  onBlur={formik.handleBlur}
                                />
                                <small>
                                  {backendErrors.numero_de_station && (
                                      <span className="form-error mt-1">
                                        {backendErrors.numero_de_station}
                                      </span>
                                    )}
                                </small>
                              </div>
                          </div>
                           <div className="col-md-6">
                            <div className="form-group">
                                <label>N ONSSA</label>
                                <input
                                  type="text"
                                  name="n_onssa"
                                  value={formik.values.n_onssa}
                                  className={
                                    backendErrors.n_onssa
                                      ? "form-input form-control input-error"
                                      : "form-input form-control"
                                  }
                                 
                                  onChange={(e) => {
                                    formik.handleChange(e);
                                    customHandleInput(e);
                                  }}
                                  onBlur={formik.handleBlur}
                                />
                                <small>
                                  {backendErrors.n_onssa && (
                                      <span className="form-error mt-1">
                                        {backendErrors.n_onssa}
                                      </span>
                                    )}
                                </small>
                              </div>
                          </div>
                          
                             <div className="col-md-6">
                              <div className="form-group">
                                  <label>N° Exportateur</label>
                                  <input
                                    type="text"
                                    name="n_exportateur"
                                    value={formik.values.n_exportateur}
                                    className={
                                      backendErrors.n_exportateur
                                        ? "form-input form-control input-error"
                                        : "form-input form-control"
                                    }
                                    
                                    onChange={(e) => {
                                      formik.handleChange(e);
                                      customHandleInput(e);
                                    }}
                                    onBlur={formik.handleBlur}
                                  />
                                  <small>
                                    {backendErrors.n_exportateur && (
                                        <span className="form-error mt-1">
                                          {backendErrors.n_exportateur}
                                        </span>
                                      )}
                                  </small>
                                </div>
                            </div>
                         <div className="col-md-12">
                            <div className="form-group">
                                <label>Description</label>
                                <textarea
                                
                                  name="description"
                                  value={formik.values.description}
                                  className={
                                    backendErrors.description
                                      ? "form-input form-control input-error"
                                      : "form-input form-control"
                                  }
                                  onChange={(e) => {
                                    formik.handleChange(e);
                                    customHandleInput(e);
                                  }}
                                  onBlur={formik.handleBlur}
                                ></textarea>
                                <small>
                                  {backendErrors.description && (
                                      <span className="form-error mt-1">
                                        {backendErrors.description}
                                      </span>
                                    )}
                                </small>
                              </div>
                          </div>
                         
                        </div>
                        <div className="row">
                          <div className="col-md-6">
                            <h4 className="card-title">
                              <br />
                              Add Certificates
                            </h4>
                            {/* <a
                              href="#!"
                              className="btn btn-primary"
                              onClick={handleShow}
                            >
                              +
                            </a> */}
                          </div>
                        </div>
                          <FieldArray
                          name="files"
                          render={(arrayHelpers) => (
                            <div>
                              <button
                                className="btn btn-primary mb-3"
                                type="button"
                                // onClick={handleShow}
                                onClick={() =>
                                  arrayHelpers.push({
                                    file_link: "",
                                    file_name: "",
                                    file_type: "",
                                    expiry_date: "",
                                    note: "",
                                    
                                  })
                                }
                              >
                                +
                              </button>
                              <table className="table">
                                <tbody>
                                  {formik.values.files.map((friend, index) => (
                                    <tr key={index}>
                                      <td>
                                        <div className="form-group status  pt-3">
                                          <label>Upload File</label><br/>
                                          
                                           <input
                                              className="form-group"
                                              type="file"
                                              name={`files[${index}].file_link`}
                                              id={`fileupload-${index}`}

                                              onChange={(event) => {
                                                getFileData(event);

                                                const file_link = event.target.files[0];
                                                //console.log("file:", file_link);
                                                //const fileName = file_link.name;
                                              // const fileName = file_link.name;
                                                const reader = new FileReader();

                                                reader.onloadend = () => {
                                                  formik.setFieldValue(
                                                    `files[${index}].file_link`,
                                                    reader.result
                                                  );
                                                };
              
                                                if (file_link) {
                                                  reader.readAsDataURL(file_link);
                                                }
                                              }}
                                            />
                                         {formik.values.files[index].link != null && (
                                              <a
                                                className="btn btn-primary"
                                                href={viewFile(formik.values.files[index].link)}
                                                target="_blank"
                                                rel="noopener noreferrer"
                                                download
                                              >
                                                Download
                                              </a>
                                            )}
                                        
                                        </div>
                                      </td>
                                       <td>
                                        <div className="form-group status">
                                          <label>File Name</label>
                                          <input
                                            type="text"
                                            className="form-input form-control"
                                            name={`files[${index}].file_name`}
                                            id={`filename-${index}`}

                                            value={
                                              formik.values.files[index]
                                                .file_name
                                            }
                                            onChange={formik.handleChange}
                                          />
                                        </div>
                                      </td>
                                      <td>
                                        <div className="form-group status">
                                          <label>File Type</label><br/>
                                          {fileTypes.length > 0 && (
                                          <Select
                                          name={`files[${index}].file_type`}
                                          options={fileTypes}
                                          value={fileTypes.find(option => option.value == formik.values.files[index].file_type) || null} // Ensure correct format
                                          onChange={(selectedOption) => {
                                            formik.setFieldValue(`files[${index}].file_type`, selectedOption.value); // ✅ Store only value in Formik
                                            customHandleInput({
                                              target: {
                                                name: `files[${index}].file_type`,
                                                value: selectedOption.value, // ✅ Ensure only value is passed
                                              },
                                            });
                                          }}
                                          onBlur={formik.handleBlur}
                                          placeholder="Select"
                                          className="w-100"
                                          />
                                            )}
                                        </div>
                                      </td>
                                     
                                      <td>
                                        <div className="form-group status">
                                          <label>Expiry Date</label>
                                          <input
                                            type="date"
                                            className="form-input form-control"
                                            name={`files[${index}].expiry_date`}
                                            value={
                                              formik.values.files[index]
                                                .expiry_date
                                            }
                                            onChange={(e) => {
                                              formik.handleChange(e);
                                              customHandleInput(e);
                                            }}
                                            onBlur={formik.handleBlur}
                                             />
                                        </div>
                                      </td>
                                      <td>
                                        <div className="form-group status">
                                          <label>Note</label>
                                          <input
                                            type="text"
                                            className="form-input form-control"
                                            name={`files[${index}].note`}
                                            value={
                                              formik.values.files[index]
                                                .note
                                            }
                                            onChange={(e) => {
                                              formik.handleChange(e);
                                              customHandleInput(e);
                                            }}
                                            onBlur={formik.handleBlur}
                                             />
                                        </div>
                                      </td>
                                      <td>
                                        <div className="form-group">
                                          <button
                                            className="btn btn-danger"
                                            style={{ marginTop: 30 }}
                                            type="button"
                                            // onClick={() =>
                                            //   arrayHelpers.remove(index)
                                            // }
                                            onClick={() =>{
                                              let item_record = formik.values.files[index];
                                              if(item_record.id == undefined){
                                                arrayHelpers.remove(index)
                                              }else{
                                                deleteItemFromDB(item_record.id);
                                                arrayHelpers.remove(index)
                                              }
                                            } }
                                          >
                                            -
                                          </button>
                                        </div>
                                      </td>
                                    </tr>
                                  ))}
                                </tbody>
                              </table>
                            </div>
                          )}
                        />
                        <div className="text-end mt-4">
                          <button type="submit" id="form-submit" className="btn btn-primary" disabled={formik.isSubmitting}>
                          Update Location
                          </button>
                        </div>
                      </form>
                    </FormikProvider>
                  </div>
                )}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};
export default LocationtableEdit;
